<div>
    <ng-container *ngIf="!ngControl?.control?.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <ng-content select="[mat-label]"></ng-content>
        <mat-form-field appearance="outline" floatLabel="always" style="width: 100%;">
            <input *ngIf="!allowTextArea" matInput #textInput 
                [formControl]="ngControl?.control"
                [placeholder]="placeholder"
                [type]="inputType" 
                [readonly]="readonly"
                [maxlength]="maxLength"
                [min]="minLength"
                (keydown)="keyDown($event)">
            <textarea *ngIf="allowTextArea" matInput rows="4" #textInput [formControl]="ngControl?.control" [maxlength]="maxLength" placeholder="{{placeholder}}"></textarea> 
            <!-- errors -->
            <!-- <mat-hint *ngIf="ngControl.control.errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}} &nbsp;</mat-hint>
            <mat-hint *ngIf="ngControl.control.errors?.email">{{'AUTH.VALIDATION.INVALID_EMAIL' | translate}} &nbsp;</mat-hint>
            <mat-hint *ngIf="ngControl.control.errors?.maxlength">{{'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}} &nbsp;</mat-hint>
            <mat-hint *ngIf="ngControl.control.errors?.max">{{'AUTH.VALIDATION.MAX_VALUE' | translate }} &nbsp;</mat-hint>
            <mat-hint *ngIf="ngControl.control.errors?.min">{{'AUTH.VALIDATION.MIN_VALUE' | translate }} &nbsp;</mat-hint>
            <mat-hint *ngIf="ngControl.control.errors?.pattern">{{'AUTH.VALIDATION.BAD_FORMAT' | translate }} &nbsp;</mat-hint>
            <mat-hint *ngIf="ngControl.control.errors?.blankSpaces">{{'AUTH.VALIDATION.BLANK_FIELD' | translate }} &nbsp;</mat-hint> -->
            
        </mat-form-field>
        
        <div fxLayout="row wrap" style="justify-content: space-between" *ngIf="dynamicFilter">
            <!-- <ng-container *ngIf="minimunCharValidation">
                <div class="input-text-hint">
                    <mat-hint class="warn-text">{{"MINIMUM_CHARACTERES_VALID" | translate}} : {{minLength}}</mat-hint>
                </div> 
            </ng-container> -->
            <ng-container *ngIf="ngControl?.control?.valid">
                <div class="input-text-hint ml-auto">
                    <mat-hint>{{ngControl?.control?.value?.length}} / {{maxLength}}</mat-hint>
                </div> 
            </ng-container>
        </div>

        <div *ngIf="!dynamicFilter">
            <ng-container *ngIf="ngControl?.control?.valid">
                <div fxLayout="row" fxLayoutAlign="flex-end" class="input-text-hint">
                    <mat-hint>{{ngControl?.control?.value?.length}} / {{maxLength}}</mat-hint>
                </div> 
            </ng-container>
        </div>

        <ng-container *ngIf="ngControl?.touched">
            <mat-error *ngIf="ngControl?.control.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
            <mat-error *ngIf="ngControl?.control.hasError('email')">{{'INPUT.INVALID_EMAIL' | translate}}</mat-error>
            <mat-error *ngIf="ngControl?.control.hasError('maxLength')">{{'INPUT.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}}</mat-error>
            <mat-error *ngIf="ngControl?.control.hasError('max')">{{'INPUT.MAX_VALUE' | translate }}</mat-error>
            <mat-error *ngIf="ngControl?.control.hasError('min')">{{'INPUT.MIN_VALUE' | translate }}</mat-error>
            <mat-error *ngIf="ngControl?.control.hasError('pattern')">{{'INPUT.BAD_FORMAT' | translate }}</mat-error>

        </ng-container>
    </ng-container>
    <ng-container *ngIf="ngControl?.control.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <ng-content select="mat-label"></ng-content>
        <p style="white-space: pre-wrap; font-weight: 600;">{{ngControl?.control.value}}</p>
    </ng-container>
</div>
